<template>
  <div class="copyformat-container">
    <div class="copy-bar" @click="isOpen = !isOpen" :class="{isOpen : isOpen}">
      <span>Copy Format:</span> {{this.currentFormat.displayText}}
    </div>
    <ul class="format-dd" v-if="isOpen" v-click-outside.stop="hide">
      <li class="format-option" @click="setFormatMethod(format.id);$ga.event('dropdown', format.id);" v-for="format in formats" :key="format.id">{{format.displayText}}</li>
      <li class="more-colors">
        <router-link class="" to="/subscribe" @click.native="$ga.event('dropdown', 'subscribe');">
          ☝️ &nbsp; &nbsp;Want more colors?
        </router-link>
      </li>
      <li class="feedback">
        <a target="_blank" @click="openCrisp();" href="javascript:;">
          👋 &nbsp; &nbsp;Feedback
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import _ from "lodash";
import ClickOutside from "vue-click-outside";

let formats = require("@/data/formats.json");

export default {
  name: "CopyFormat",
  components: {},
  computed: {
    ...mapState(["format"]),
    currentFormat() {
      return _.find(this.formats, { id: this.format });
    }
  },
  data() {
    return {
      isOpen: false,
      formats
    };
  },
  directives: {
    ClickOutside
  },
  methods: {
    ...mapMutations(["setFormat"]),
    setFormatMethod(newFormat) {
      this.isOpen = false;
      this.setFormat(newFormat);
    },
    hide: function() {
      this.isOpen = false;
    },
    openCrisp(){
      this.$ga.event('dropdown', 'feedback');
      $crisp.push(["do", "chat:open"]);
      $crisp.push(["do", "chat:show"]);
      this.hide();
    }
  }
};
</script>
<style lang="scss" scoped>
.copyformat-container {
  display: block;
  position: absolute;
  left: 50% ;
  margin-left: -135px;
  top: 7px;
  .copy-bar {
    background: #000;
    border-radius: 4px;
    width: 270px;
    height: 36px;
    line-height: 34px;
    text-align: center;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    text-indent: -24px;
    user-select: none;
    transition: all 0.2s;
    letter-spacing: 1px;
    span {
      letter-spacing: 0px;
    }
    &:after {
      display: block;
      content: "▲";
      right: 38px;
      font-size: 12px;
      position: absolute;
      top: 2px;
      transform: rotate(180deg);
      text-indent: inherit;
    }
    &.isOpen {
      &:after {
        transform: rotate(0deg);
        top: 0px;
        right: 14px;
      }
    }
    &:active {
      transform: scale(0.97);
    }
  }
}
.format-dd {
  width: 270px;
  position: fixed;
  background: #fff;
  //     height: 120px;
  z-index: 100;
  display: block;
  left: calc(50%);
  margin-left: -135px;
  margin-top: 20px;
  border-radius: 5px;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: #000;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.31),
    0 1px 13px 10px rgba(0, 0, 0, 0.02);

  animation-name: animJelly;
  animation-duration: 1s;
  animation-timing-function: linear;
  li {
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    border-bottom: 1px solid #ecf0f1;
    user-select: none;
    letter-spacing: 1px;
    &:last-child {
      border-bottom: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    &:first-child {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    &:hover {
      background: black;
      color: #fff;
      a {
        color: #fff;
      }
    }
  }
  .feedback,
  .more-colors {
    a {
      width: 100%;
      display: inline-block;
      color: #000;
      letter-spacing: 0px;
    }
  }
}
@keyframes animJelly {
  0% {
    -webkit-transform: matrix3d(
      0.7,
      0,
      0,
      0,
      0,
      0.7,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(0.7, 0, 0, 0, 0, 0.7, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  2.083333% {
    -webkit-transform: matrix3d(
      0.75266,
      0,
      0,
      0,
      0,
      0.76342,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.75266,
      0,
      0,
      0,
      0,
      0.76342,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  4.166667% {
    -webkit-transform: matrix3d(
      0.81071,
      0,
      0,
      0,
      0,
      0.84545,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.81071,
      0,
      0,
      0,
      0,
      0.84545,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  6.25% {
    -webkit-transform: matrix3d(
      0.86808,
      0,
      0,
      0,
      0,
      0.9286,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.86808,
      0,
      0,
      0,
      0,
      0.9286,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  8.333333% {
    -webkit-transform: matrix3d(
      0.92038,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(0.92038, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  10.416667% {
    -webkit-transform: matrix3d(
      0.96482,
      0,
      0,
      0,
      0,
      1.05202,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.96482,
      0,
      0,
      0,
      0,
      1.05202,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  12.5% {
    -webkit-transform: matrix3d(
      1,
      0,
      0,
      0,
      0,
      1.08204,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(1, 0, 0, 0, 0, 1.08204, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  14.583333% {
    -webkit-transform: matrix3d(
      1.02563,
      0,
      0,
      0,
      0,
      1.09149,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.02563,
      0,
      0,
      0,
      0,
      1.09149,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  16.666667% {
    -webkit-transform: matrix3d(
      1.04227,
      0,
      0,
      0,
      0,
      1.08453,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.04227,
      0,
      0,
      0,
      0,
      1.08453,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  18.75% {
    -webkit-transform: matrix3d(
      1.05102,
      0,
      0,
      0,
      0,
      1.06666,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.05102,
      0,
      0,
      0,
      0,
      1.06666,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  20.833333% {
    -webkit-transform: matrix3d(
      1.05334,
      0,
      0,
      0,
      0,
      1.04355,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.05334,
      0,
      0,
      0,
      0,
      1.04355,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  22.916667% {
    -webkit-transform: matrix3d(
      1.05078,
      0,
      0,
      0,
      0,
      1.02012,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.05078,
      0,
      0,
      0,
      0,
      1.02012,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  25% {
    -webkit-transform: matrix3d(
      1.04487,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(1.04487, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  27.083333% {
    -webkit-transform: matrix3d(
      1.03699,
      0,
      0,
      0,
      0,
      0.98534,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.03699,
      0,
      0,
      0,
      0,
      0.98534,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  29.166667% {
    -webkit-transform: matrix3d(
      1.02831,
      0,
      0,
      0,
      0,
      0.97688,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.02831,
      0,
      0,
      0,
      0,
      0.97688,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  31.25% {
    -webkit-transform: matrix3d(
      1.01973,
      0,
      0,
      0,
      0,
      0.97422,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.01973,
      0,
      0,
      0,
      0,
      0.97422,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  33.333333% {
    -webkit-transform: matrix3d(
      1.01191,
      0,
      0,
      0,
      0,
      0.97618,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.01191,
      0,
      0,
      0,
      0,
      0.97618,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  35.416667% {
    -webkit-transform: matrix3d(
      1.00526,
      0,
      0,
      0,
      0,
      0.98122,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00526,
      0,
      0,
      0,
      0,
      0.98122,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  37.5% {
    -webkit-transform: matrix3d(
      1,
      0,
      0,
      0,
      0,
      0.98773,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(1, 0, 0, 0, 0, 0.98773, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  39.583333% {
    -webkit-transform: matrix3d(
      0.99617,
      0,
      0,
      0,
      0,
      0.99433,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99617,
      0,
      0,
      0,
      0,
      0.99433,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  41.666667% {
    -webkit-transform: matrix3d(
      0.99368,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(0.99368, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  43.75% {
    -webkit-transform: matrix3d(
      0.99237,
      0,
      0,
      0,
      0,
      1.00413,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99237,
      0,
      0,
      0,
      0,
      1.00413,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  45.833333% {
    -webkit-transform: matrix3d(
      0.99202,
      0,
      0,
      0,
      0,
      1.00651,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99202,
      0,
      0,
      0,
      0,
      1.00651,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  47.916667% {
    -webkit-transform: matrix3d(
      0.99241,
      0,
      0,
      0,
      0,
      1.00726,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99241,
      0,
      0,
      0,
      0,
      1.00726,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  50% {
    -webkit-transform: matrix3d(
      0.99329,
      0,
      0,
      0,
      0,
      1.00671,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99329,
      0,
      0,
      0,
      0,
      1.00671,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  52.083333% {
    -webkit-transform: matrix3d(
      0.99447,
      0,
      0,
      0,
      0,
      1.00529,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99447,
      0,
      0,
      0,
      0,
      1.00529,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  54.166667% {
    -webkit-transform: matrix3d(
      0.99577,
      0,
      0,
      0,
      0,
      1.00346,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99577,
      0,
      0,
      0,
      0,
      1.00346,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  56.25% {
    -webkit-transform: matrix3d(
      0.99705,
      0,
      0,
      0,
      0,
      1.0016,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99705,
      0,
      0,
      0,
      0,
      1.0016,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  58.333333% {
    -webkit-transform: matrix3d(
      0.99822,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(0.99822, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  60.416667% {
    -webkit-transform: matrix3d(
      0.99921,
      0,
      0,
      0,
      0,
      0.99884,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99921,
      0,
      0,
      0,
      0,
      0.99884,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  62.5% {
    -webkit-transform: matrix3d(
      1,
      0,
      0,
      0,
      0,
      0.99816,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(1, 0, 0, 0, 0, 0.99816, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  64.583333% {
    -webkit-transform: matrix3d(
      1.00057,
      0,
      0,
      0,
      0,
      0.99795,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00057,
      0,
      0,
      0,
      0,
      0.99795,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  66.666667% {
    -webkit-transform: matrix3d(
      1.00095,
      0,
      0,
      0,
      0,
      0.99811,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00095,
      0,
      0,
      0,
      0,
      0.99811,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  68.75% {
    -webkit-transform: matrix3d(
      1.00114,
      0,
      0,
      0,
      0,
      0.99851,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00114,
      0,
      0,
      0,
      0,
      0.99851,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  70.833333% {
    -webkit-transform: matrix3d(
      1.00119,
      0,
      0,
      0,
      0,
      0.99903,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00119,
      0,
      0,
      0,
      0,
      0.99903,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  72.916667% {
    -webkit-transform: matrix3d(
      1.00114,
      0,
      0,
      0,
      0,
      0.99955,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00114,
      0,
      0,
      0,
      0,
      0.99955,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  75% {
    -webkit-transform: matrix3d(
      1.001,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(1.001, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  77.083333% {
    -webkit-transform: matrix3d(
      1.00083,
      0,
      0,
      0,
      0,
      1.00033,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00083,
      0,
      0,
      0,
      0,
      1.00033,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  79.166667% {
    -webkit-transform: matrix3d(
      1.00063,
      0,
      0,
      0,
      0,
      1.00052,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00063,
      0,
      0,
      0,
      0,
      1.00052,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  81.25% {
    -webkit-transform: matrix3d(
      1.00044,
      0,
      0,
      0,
      0,
      1.00058,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00044,
      0,
      0,
      0,
      0,
      1.00058,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  83.333333% {
    -webkit-transform: matrix3d(
      1.00027,
      0,
      0,
      0,
      0,
      1.00053,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00027,
      0,
      0,
      0,
      0,
      1.00053,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  85.416667% {
    -webkit-transform: matrix3d(
      1.00012,
      0,
      0,
      0,
      0,
      1.00042,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      1.00012,
      0,
      0,
      0,
      0,
      1.00042,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  87.5% {
    -webkit-transform: matrix3d(
      1,
      0,
      0,
      0,
      0,
      1.00027,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(1, 0, 0, 0, 0, 1.00027, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  89.583333% {
    -webkit-transform: matrix3d(
      0.99991,
      0,
      0,
      0,
      0,
      1.00013,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99991,
      0,
      0,
      0,
      0,
      1.00013,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  91.666667% {
    -webkit-transform: matrix3d(
      0.99986,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(0.99986, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  93.75% {
    -webkit-transform: matrix3d(
      0.99983,
      0,
      0,
      0,
      0,
      0.99991,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99983,
      0,
      0,
      0,
      0,
      0.99991,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  95.833333% {
    -webkit-transform: matrix3d(
      0.99982,
      0,
      0,
      0,
      0,
      0.99985,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99982,
      0,
      0,
      0,
      0,
      0.99985,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  97.916667% {
    -webkit-transform: matrix3d(
      0.99983,
      0,
      0,
      0,
      0,
      0.99984,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    transform: matrix3d(
      0.99983,
      0,
      0,
      0,
      0,
      0.99984,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
  }
  100% {
    -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CopyFormat.vue